export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_LOAD_PROFILE_ERROR = 'AUTH_LOAD_PROFILE_ERROR'
export const AUTH_SHOW_AVAILABLE = 'AUTH_SHOW_AVAILABLE'
export const AUTH_SELECT_ACCOUNT = 'AUTH_SELECT_ACCOUNT'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_LOAD_LOGIN_PROFILE = 'AUTH_LOAD_LOGIN_PROFILE'
export const AUTH_REFRESH_PROFILE = 'AUTH_REFRESH_PROFILE'
export const AUTH_REFRESH_PROFILE_COMPLETE = 'AUTH_REFRESH_PROFILE_COMPLETE'
export const AUTH_LEGACY_LOGIN = 'AUTH_LEGACY_LOGIN'
export const AUTH_LEGACY_FAIL = 'AUTH_LEGACY_FAIL'


export default {
  AUTH_LOGIN,
  AUTH_FAIL,
  AUTH_LOGOUT,
  AUTH_SHOW_AVAILABLE,
  AUTH_SELECT_ACCOUNT,
  AUTH_LOAD_PROFILE_ERROR,
  AUTH_LOAD_LOGIN_PROFILE,
  AUTH_REFRESH_PROFILE,
  AUTH_REFRESH_PROFILE_COMPLETE,
  AUTH_LEGACY_LOGIN,
  AUTH_LEGACY_FAIL
}



// WEBPACK FOOTER //
// ./src/containers/Auth/store/actionTypes.js